import io from 'socket.io-client';
import session from '../models/Session';
import history from '../libraries/History';
import config from '../config'; 
// import EventEmitter from 'eventemitter3';

const socket = io(config.backend.uri, {
  path: '/events',
  reconnection: true,
});

// const socket = new EventEmitter()
function isDraftSessionLeader() {
  const user = session.get('user');
  const draft = session.get('draft'); 
  return user && draft && draft.createdBy && user._id && draft.createdBy._id === user._id;
}

function senderIsLeader(senderId, createdById){
  return senderId === createdById;
}

function receiverIsLeader(receiverId, createdById){
  return receiverId === createdById;
}

function senderIsReceiver(senderId,receiverId){
  console.log(senderId)
  console.log(receiverId)
  return senderId === receiverId
}

function isDraftSessionParticipant() {

  const user = session.get('user');
  const draft = session.get('draft');
  return user && draft;
}

Object.assign(socket, {
  syncWithParticipants: () => {
    const user = session.get('user');
    const draft = session.get('draft'); 

    if (isDraftSessionLeader()) {

      console.log('Syncing session path', {
        pathname: window.location.pathname, 
        draftId: draft._id,
        datetime: Date.now()
      });

      socket.emit('sync session path', {
        pathname: window.location.pathname, 
        draftId: draft._id,
        datetime: Date.now()
      });
    }
  }, 
  syncChangesWithParticipants: (changes) => {
    console.log('Syncing changes with participants', changes); 

    socket.emit('session field changed', Object.assign({}, changes, {
      draftId: session.get('draft')._id, 
      draftSessionId: session.get('draftSession')._id,
      draftSessionCreatedAt: session.get('draftSession').createdAt,
      fields: session.get('draftSession').fields,
      from: session.get('user')._id,
      datetime: Date.now()
    }));
  },
  auth: () => {
    socket.emit('authentication', { userId: session.user._id});
  }
});



socket.on('sync session path', data => {
  if (isDraftSessionLeader()) {
    return; 
  }

  const { draftId, pathname } = data; 
  if ( session.get('draft') && draftId === session.get('draft')._id && window.location.pathname !== pathname) {
    history.replace(pathname); 
  }
  console.log('Received sync session path', data); 
});

socket.on('session field changed', data => {

  if(senderIsReceiver(data.from, session.get('user')._id)){
    return;
  }

  /*if (senderIsLeader(data.from,session.get('draft').createdBy._id) && receiverIsLeader(session.get('user')._id,session.get('draft').createdBy._id)) {
    return; 
  } */

  const { draftId, draftSessionId, fields, draftSessionCreatedAt } = data; 

  if (session.get('draftSession') && session.get('draftSession')._id === draftSessionId) {
    session.set({
      draftSession: session.get('draftSession').set({fields: {...fields}, createdAt: new Date(draftSessionCreatedAt) })
    })
  }
  console.log('Got session field change, draftSession updated', data, session.get('draftSession'));
});


  // this.socket = io(process.env.REACT_APP_BACKEND_URI, {
export default socket; 


// WEBPACK FOOTER //
// ./src/libraries/socket.js